import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20">
      <div className="max-w-4xl mx-auto relative overflow-hidden rounded-2xl">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20shapes%2C%20coral%20and%20amber%20color%20tones%2C%20minimalist%20modern%20design%2C%20smooth%20organic%20curves%2C%20ethereal%20atmosphere%2C%20professional%20quality%2C%20inviting%20warm%20color%20palette&width=1200&height=500&seq=cta-bg-01&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-500/90 to-accent-500/90"></div>
        <div className="relative z-10 py-14 px-6 md:px-12 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3">
            即刻获取91免费客户端的app
          </h2>
          <p className="text-sm md:text-base text-background-100/90 mb-8 max-w-lg mx-auto">
            支持安卓、苹果、Windows、Mac全平台，流畅稳定的免费看片体验，现在就开始使用吧！
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/android-app"
              className="px-8 py-3 bg-background-50 text-primary-600 rounded-full font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              安卓下载
            </Link>
            <Link
              to="/category/ios-app"
              className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap"
            >
              苹果下载
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}